import { motion } from 'framer-motion';
import axios from 'axios';
import React from 'react';
import { useForm } from 'react-hook-form';
import './ContactUs.css'; // Import the plain CSS file

const ContactUs = ({ setSelectedPage }) => {
  const {
    register,
    trigger,
    getValues,
    reset, // Import reset method
    formState: { errors },
  } = useForm();

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page refresh

    const isValid = await trigger(); // Validate the form
    if (!isValid) {
      // Form is not valid, so no further action
    } else {
      const formData = getValues();
      const dataObject = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      console.log(dataObject);
      
      axios.post("http://localhost:9000/contact",dataObject)
	  .then(res=>{
		console.log('store');
	  })
	  .catch(err=>{
		console.log(err);
		
	  })
      reset();
    }
  };

  return (
   
    <section id="contactus" className="section-container">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        onAnimationComplete={() => setSelectedPage('ContactUs')}
      >
        <span className="heading-text">JOIN NOW</span> TO GET IN SHAPE
        <p className="subheading-text">
          We provide world-class fitness equipment, trainers, and classes to get you to your ultimate fitness goals with ease. We provide true care into each and every member.
        </p>
      </motion.div>

      <div className="flex-container">
        <motion.div
          className="flex-child"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              className="input"
              placeholder="Enter your name"
              {...register('name', { required: true, maxLength: 100 })}
            />
            {errors.name && (
              <p className="error-text">
                {errors.name.type === 'required' && 'This field is required.'}
                {errors.name.type === 'maxLength' && 'Maximum length is 100 characters.'}
              </p>
            )}

            <input
              type="email"
              className="input"
              placeholder="Enter your email address"
              {...register('email', { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i })}
            />
            {errors.email && (
              <p className="error-text">
                {errors.email.type === 'required' && 'This field is required.'}
                {errors.email.type === 'pattern' && 'The email address is invalid.'}
              </p>
            )}

            <textarea
              className="input"
              rows={4}
              placeholder="Enter your message"
              {...register('message', { required: true, maxLength: 2000 })}
            />
            {errors.message && (
              <p className="error-text">
                {errors.message.type === 'required' && 'This field is required.'}
                {errors.message.type === 'maxLength' && 'Maximum length is 2000 characters.'}
              </p>
            )}

            <button type="submit" className="submit-btn">SUBMIT</button>
          </form>
        </motion.div>

        <motion.div
          className="flex-child-alt"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="img relative">
            <img src='ContactUsPageGraphic.png' alt="contact-us" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactUs;